import { createCircleIcon } from '../createIcon.tsx';

/** The signed-in person: a head and shoulders inside the standard disc. The account glyph -- distinct from the bare
 *  `UserIcon`, so an account control and a profile tab on one screen never draw alike. */
export const UserCircleIcon = createCircleIcon(
	'UserCircleIcon',
	<>
		<circle cx="12" cy="10" r="3" />
		<path d="M6.2 18.4a7 7 0 0 1 11.6 0" />
	</>,
);
